import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import { FormattedMessage, useIntl } from "react-intl";
import ChevronIcon from "svg-icons/chevron-icon.js";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant.js";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang.js";
import { useDispatch, useSelector } from "react-redux";
import "./../subscribeForm/subscribeForm.scss";
import MicroFileItemForm from "./microfile-form-item.jsx";
import ContentLoading from "component/LoadingComponent/ContentLoading.js";
import MainDepartment from "component/shared/main-department/MainDepartment.jsx";
import HtmlView from "component/htmlView/html-view.js";
import AboutDepartment from "component/shared/about-department/AboutDepartment.jsx";
import fetch from "auth/FetchInterceptor";
import { MESSAGE_TYPE } from "redux/constants/ApiMessageResponse.js";
import { apiResponseMessage } from "redux/actions/ApiMessageResponse.js";
import ReactGA from "react-ga4";

function Microfilm() {
  const intl = useIntl();

  const dir = useSelector(({ theme }) => theme.direction);
  const currentLocale = useSelector(({ theme }) => theme.locale);
  const dispatch = useDispatch();

  const userInfo = useSelector(({ auth }) => auth);

          
  ReactGA.initialize(END_POINTS.TRACKING_ID)

  useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/microfilm", title: "Microfilm Page" });
  }, []);


  const formSchema = Yup.object().shape({
    filmCount: Yup.string()
      .matches(/^[0-9]*$/)
      .required(),
    agencyName: Yup.string().required(),
  });
  const formOptions = {
    resolver: yupResolver(formSchema),
    defaultValues: {
      serviceTypeId: "1",
      agencyTypeId: "1",
      filmTypeId: "1",
    },
  };
  const { control, register, handleSubmit, reset, formState } =
    useForm(formOptions);
  const { errors } = formState;

  const [data, setData] = useState("");

  const onSubmit = async (data) => {
    try {
      var result = await postMicroFilm(data);
      if (result?.state) {
        dispatch(
          apiResponseMessage({
            showMessage: true,
            message: <FormattedMessage id="sent-successfully" />,
            messageType: MESSAGE_TYPE.SUCCESS,
          })
        );
      } else {
        dispatch(
          apiResponseMessage({
            showMessage: true,
            message: result?.data?.message ? (
              result?.data?.message
            ) : (
              <FormattedMessage id="timeout-error" />
            ),
            messageType: MESSAGE_TYPE.ERROR,
          })
        );
      }
    } catch (error) {
      dispatch(
        apiResponseMessage({
          showMessage: true,
          message: error?.response?.data?.message ? (
            error?.response?.data?.message
          ) : (
            <FormattedMessage id="timeout-error" />
          ),
          messageType: MESSAGE_TYPE.ERROR,
        })
      );
    }
  };

  const getServices = useSWR({
    url: END_POINTS.SERVICE_TYPE,
  });
  const Services =
    getServices.error ||
    getServices.isLoading ||
    getServices.data === undefined ||
    getServices.data === null
      ? []
      : getServices.data.data;

  const getAgency = useSWR({
    url: END_POINTS.AGENCY_TYPE,
  });
  const Agency =
    getAgency.error ||
    getAgency.isLoading ||
    getAgency.data === undefined ||
    getAgency.data === null
      ? []
      : getAgency.data.data;

  const getFilm = useSWR({
    url: END_POINTS.FILM_TYPE,
  });
  const Film =
    getFilm.error ||
    getFilm.isLoading ||
    getFilm.data === undefined ||
    getFilm.data === null
      ? []
      : getFilm.data.data;

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  async function postMicroFilm(data) {
    var microFilmData = {
      serviceTypeId: data.serviceTypeId, //need to be added to the database still
      agencyName: data.agencyName,
      agencyTypeId: data.agencyTypeId,
      filmTypeId: data.filmTypeId,
      filmCount: data.filmCount,
      isPublished: true,
      status: 3,
      //"userId": data.userId  //how get the userId
    };
    return await fetch.post(END_POINTS.MICROFILM, microFilmData);
  }

  const getDepartment = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS_DEPARTMENT}=${END_POINTS.MICROFILM_DEPARTMENT_ID}`,
  });

  const getServicesTools = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS}/${END_POINTS.MICROFILM_DEPARTMENT_ID}`,
  });

  return (
    <ContentLoading
      isLoading={
        getDepartment.isLoading ||
        getServicesTools.isLoading ||
        getServices.isLoading ||
        getAgency.isLoading ||
        getFilm.isLoading
      }
    >
      <div className="microfilm">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "service-tools" }),
              clickClass: false,
            },
            {
              title: intl.formatMessage({ id: "microfilm-services" }),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "microfilm-title" })}
          route={"../servicestools"}
        />

        <div className="container py-5">
          <div className="row">
            <div className="col-lg-8">
              <div className="m__title">
                <h3>
                  <FormattedMessage id="microfilm" />
                </h3>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="service-type" />:
                    </label>
                  </div>

                  <div className="col-lg-8">
                    <div className="dropdown">
                      <select
                        className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
                        {...register("serviceTypeId")}
                      >
                        {Services.map(
                          ({ id, name, serviceTypeTranslations }, i) => (
                            <option
                              key={i}
                              value={id}
                              title={LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: name,
                                translations: serviceTypeTranslations,
                              })}
                            >
                              <LabelLang
                                id={"name"}
                                defaultValue={name}
                                translations={serviceTypeTranslations} //Until translations are made
                              />
                            </option>
                          )
                        )}
                      </select>
                      <span>*</span>
                    </div>
                  </div>
                </div>

                {/* <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="first-name" />:
                    </label>
                  </div>
                  <div className="col-lg-8">
                    <div className="form-label-container">
                      <input type="text" className=" form-control" {...register("firstName")} />
                      <span>*</span>
                    </div>
                  </div>
                </div>

                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="last-name" />:
                    </label>
                  </div>

                  <div className="col-lg-8">
                    <div className="form-label-container">
                      <input type="text" {...register("lastName")} />
                      <span>*</span>
                    </div>
                  </div>
                </div> */}
                <MicroFileItemForm
                  label={intl.formatMessage({ id: "clientFirstName" })}
                  isOptional={true}
                >
                  <input
                    type="text"
                    disabled
                    value={userInfo.firstName}
                    className={"form-control"}
                  />
                </MicroFileItemForm>
                <MicroFileItemForm
                  label={intl.formatMessage({ id: "clientLastName" })}
                  isOptional={true}
                >
                  <input
                    type="text"
                    disabled
                    value={userInfo.lastName}
                    className={"form-control"}
                  />
                </MicroFileItemForm>
                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="entity-name" />:
                    </label>
                  </div>

                  <div className="col-lg-8">
                    <div className="form-label-container">
                      <input
                        type="text"
                        {...register("agencyName")}
                        className={`form-control ${
                          errors.agencyName ? "is-invalid" : ""
                        }`}
                      />
                      <span>*</span>
                    </div>
                  </div>
                </div>
                <MicroFileItemForm
                  label={intl.formatMessage({ id: "email" })}
                  isOptional={true}
                >
                  <input
                    type="text"
                    disabled
                    value={userInfo.email}
                    className={"form-control"}
                  />
                </MicroFileItemForm>
                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="entity-type" />:
                    </label>
                  </div>

                  <div className="col-lg-8">
                    <div className="dropdown">
                      <select
                        className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
                        {...register("agencyTypeId")}
                      >
                        {Agency.map(
                          ({ id, name, agencyTypeTranslations }, i) => (
                            <option
                              key={i}
                              value={id}
                              title={LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: name,
                                translations: agencyTypeTranslations,
                              })}
                            >
                              <LabelLang
                                id={"name"}
                                defaultValue={name}
                                translations={agencyTypeTranslations} //Until translations are made
                              />
                            </option>
                          )
                        )}
                      </select>
                      <span>*</span>
                    </div>
                  </div>
                </div>

                {/* <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="email" />:
                    </label>
                  </div>
                  <div className="col-lg-8">
                    <div className="form-label-container">
                      <input type="text" {...register("email")} />
                      <span>*</span>
                    </div>
                  </div>
                </div>

                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="mobile" />:
                    </label>
                  </div>

                  <div className="col-lg-8">
                    <div className="form-label-container">
                      <input type="text" {...register("phone")} />
                      <span>*</span>
                    </div>
                  </div>
                </div>

                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="Address" />:
                    </label>
                  </div>

                  <div className="col-lg-8">
                    <div className="form-label-container">
                      <input type="text" {...register("address")} />
                      <span>*</span>
                    </div>
                  </div>
                </div> */}
                <MicroFileItemForm
                  label={intl.formatMessage({ id: "address" })}
                >
                  <input type="text" className={"form-control"} />
                </MicroFileItemForm>
                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="film-type" />
                    </label>
                  </div>

                  <div className="col-lg-8">
                    <div className="dropdown">
                      <select
                        className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
                        {...register("filmTypeId")}
                      >
                        {Film.map(({ id, name, filmTypeTranslations }, i) => (
                          <option
                            key={i}
                            value={id}
                            title={LabelLangString({
                              id: "name",
                              currentLocale: currentLocale,
                              defaultValue: name,
                              translations: filmTypeTranslations,
                            })}
                          >
                            <LabelLang
                              id={"name"}
                              defaultValue={name}
                              translations={filmTypeTranslations} //Until translations are made
                            />
                          </option>
                        ))}
                      </select>
                      <span>*</span>
                    </div>
                  </div>
                </div>

                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="film-number" />
                    </label>
                  </div>

                  <div className="col-lg-8">
                    <div className="form-label-container">
                      <input
                        type="text"
                        {...register("filmCount")}
                        className={`form-control ${
                          errors.filmCount ? "is-invalid" : ""
                        }`}
                      />
                      <span>*</span>
                    </div>
                  </div>
                </div>

                <div className="row-r mt-4">
                  <button className="main-btn" type="submit">
                    <span>
                      <FormattedMessage id="send" />
                    </span>
                    <ChevronIcon width={12} height={12} color="#FFFFFF" />
                  </button>
                </div>
              </form>
            </div>

            <div className="col-lg-4">
              <AboutDepartment
                id={"about"}
                txt={getServicesTools?.data?.data?.about}
                translations={
                  getServicesTools?.data?.data?.serviceAndToolTranslation
                }
              />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-12 col-lg-8">
              <div className="calnd-info">
                {getServicesTools?.data?.data?.content !== null &&
                getServicesTools?.data?.data?.content !== undefined ? (
                  <HtmlView
                    html={LabelLangString({
                      id: "content",
                      currentLocale: currentLocale,
                      defaultValue: getServicesTools?.data?.data?.content,
                      translations:
                        getServicesTools?.data?.data?.serviceAndToolTranslation,
                    })}
                  />
                ) : (
                  <FormattedMessage id="data-not-found" />
                )}
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <MainDepartment getDepartment={getDepartment} />
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default Microfilm;
